import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';

import TextIconCollection from '../../../Core/TextIconCollection';
import Image from '../../../Core/Image';
import Container from '../../../Core/Container';

export const StyledContainer = styled(Container)`
  margin: 40px auto;
  max-width: ${themeGet('media.grid')};
  width: calc(100% - ${themeGet('media.grid-gutter.2')});

  @media only screen and (min-width: ${themeGet('breakpoints.sm')}) {
    width: calc(100% - ${themeGet('media.grid-gutter.3')});
  }

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    width: calc(100% - ${themeGet('media.grid-gutter.3')});
    margin: 100px auto;
  }

  &.application-blade {
    width: 100%;
    margin: 1rem auto;
  }
`;

export const Block = styled.div`
  margin: -15px;
  // display: flex;
  // flex-direction: column;

  &.column {
    // flex-direction: column;

    > div {
      max-width: 100%;
    }
  }

  ${StyledContainer}.application-blade & {
    margin: 0 2rem;
    padding: 2rem;
    border: 1px solid ${themeGet('colors.border-grey')};
    align-items: center;
  }

  @media only screen and (min-width: 679px) {
    // flex-direction: row;
    // justify-content: space-between;

    &.center {
      align-items: center;
    }
  }
`;

export const Img = styled(Image)`
  margin: 15px auto;
  width: 100%;
  max-width: 215px;
  object-fit: contain;
  object-position: center;
  background-position: center;
  background-size: contain;
  background-repeat: no-repeat;
  display: flex;
  flex: 0 0 auto;

  ${StyledContainer}.application-blade & {
    margin: 15px auto;
    max-width: 240px;
    max-height: 160px;

    & > div {
      padding-bottom: 67% !important;
    }
  }

  @media only screen and (min-width: 444px) {
    margin: 15px;
    min-width: 215px;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    max-width: 335px;
    min-width: auto;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.xlg')}) {
    max-width: 350px;
  }
`;

export const Body = styled.div`
  margin: 15px;
  max-width: 820px;

  h2,
  h3 {
    margin-bottom: 2rem;
  }

  &.interest-rates-no-image {
    display: flex;
    flex-direction: column;
    max-width: none;
    & > h2,
    & > h3 {
      margin-bottom: 1rem;
      padding-right: 1.5rem;
    }
    li {
      width: 50%;
      p {
        font-size: 12px;
      }
    }
  }

  ${StyledContainer}.application-blade & {
    margin: 0 0 0 1rem;
    h2 {
      font-size: 1.5rem;
      line-height: 2rem;
      margin-bottom: 1.25rem;
    }

    p {
      font-size: 1rem;
      line-height: 1.5rem;
    }
  }

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    &.interest-rates-no-image {
      li {
        /* h4 {
          font-size: 42px;
        } */
        p {
          font-size: 14px;
        }
      }
    }
  }

  @media only screen and (min-width: ${themeGet('breakpoints.xlg')}) {
    width: 100%;
    &.interest-rates-no-image {
      max-width: inherit;
      flex-direction: row;
      & > h2,
      & > h3 {
        /* & > h4 { */
        width: 54%;
      }
      li {
        /* h4 {
          font-size: 52px;
        } */
        p {
          font-size: 16px;
        }
      }
    }
  }
`;

export const CopyWrapper = styled.div`
  padding: 0;
  margin-bottom: 2rem;
`;

export const Features = styled(TextIconCollection)`
  padding: 0;
  margin: 1rem 0;

  ${Body}.interest-rates-no-image & {
    padding: 0;
    margin: -1rem 0;
  }
`;

export const Footer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: -15px;

  a,
  button {
    margin: 15px;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.sm')}) {
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  ${StyledContainer}.application-blade & {
    align-items: start;

    @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
      align-items: center;
    }

    a {
      font-size: 0.875rem;
    }
  }
`;

export const BodyWrapper = styled.div`
  display: flex;
  flex-direction: column;

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }
`;

export const Disclaimer = styled.div`
  margin-top: 30px;
  p {
    color: ${themeGet('colors.secondary-text')};
    font-size: 14px;
    line-height: 1.25rem;
  }
`;
